<template>
    <div class="justify-center align-center">
        <DialogoTurno ref="refDialogoTurno" titulo="Confirmar turno" @closeFormNuevoTurnos="linkWithModal" />
        <ValidationObserver ref="obs" v-slot="{ invalid }">
            <v-form @submit.prevent="onSubmit">
                <v-card-title class="font-weight-bold primary--text pa-0 text-h5">
                    Solicitar un turno
                </v-card-title>
                <v-row class="d-flex flex-row-reverse justify-center pa-1">
                    <v-col cols="12" md="5" v-if="$vuetify.breakpoint.mdAndUp" class="d-flex justify-center">
                        <ValidationProvider>
                            <div @click="handleCalendarClick">
                                <v-date-picker v-model="nuevoTurno.fecha" @input="fechaSeleccionada"
                                    :allowed-dates="disablePastDates" :disabled="nuevoTurno.idDistrito == ''"
                                    elevation="6" class="rounded-0">
                                </v-date-picker>
                            </div>
                        </ValidationProvider>
                    </v-col>
                    <v-col cols="12" md="7" class="mt-5">
                        <div class="pb-5">
                            <v-slide-y-transition>
                                <v-alert v-if="dismissible" dense dark class="rounded-0 " color="orange darken-3"
                                    :dismissible="dismissible" key="alertKey" @input=handleDismissible>
                                    Debe seleccionar el distrito y luego seleccionar la fecha.
                                </v-alert>
                            </v-slide-y-transition>
                        </div>
                        <v-row>
                            <v-col cols="12" md="6">
                                <ValidationProvider rules="required" v-slot="v">
                                    <v-select dense v-model="nuevoTurno.idDistrito" @change="changeDistri"
                                        :items="distritos" return-object label="Seleccione distrito"
                                        item-text="desdistrito" item-value="id">
                                    </v-select>
                                </ValidationProvider>
                            </v-col>
                            <v-col cols="12" md="6" v-if="!$vuetify.breakpoint.mdAndUp">
                                <div class="d-flex justify-center">
                                    <ValidationProvider>
                                        <v-date-picker v-model="nuevoTurno.fecha" @input="fechaSeleccionada" width="315"
                                            :allowed-dates="disablePastDates" :disabled="nuevoTurno.idDistrito == ''"
                                            elevation="6" class="rounded-0"></v-date-picker>
                                    </ValidationProvider>
                                </div>
                            </v-col>
                            <v-col cols="12" md="6" :class="($vuetify.breakpoint.mdAndUp) ? '' : 'mt-5'">
                                <ValidationProvider rules="required" v-slot="v">
                                    <v-text-field dense v-model="fechaFormateada" readonly :error-messages="v.errors[0]"
                                        label="Fecha de turno">
                                    </v-text-field>
                                </ValidationProvider>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="12" md="12">
                                <ValidationProvider rules="required" v-slot="v">
                                    <v-text-field dense v-model="nuevoTurno.direccion" readonly
                                        label="Direccion"></v-text-field>
                                </ValidationProvider>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="12" md="12">
                                <ValidationProvider rules="required" v-slot="v">
                                    <v-select v-model="nuevoTurno.hora" :items="horarios" :error-messages="v.errors[0]"
                                        dense label="Horario de atención"
                                        :item-text="item => `${item.hora.toString().padStart(2, '0')}:${(item.minuto.toString().padStart(2, '0'))}`"
                                        return-item></v-select>
                                </ValidationProvider>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="12" md="12">
                                <ValidationProvider rules="required" v-slot="v">
                                    <v-select v-model="nuevoTurno.motivo" dense :items="itemMotivo" label="Motivo"
                                        required></v-select>
                                </ValidationProvider>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="12" md="12">
                                <ValidationProvider rules="required|email" v-slot="v">
                                    <v-text-field dense v-model="nuevoTurno.mail" @click="setMail"
                                        :placeholder="emailAuth" :error-messages="v.errors[0]"
                                        label="E-mail"></v-text-field>
                                </ValidationProvider>
                            </v-col>

                            <v-col cols="12" md="12" class="d-flex justify-end">
                                <v-btn type="onSubmit" :disabled="invalid" elevation="0" color="primary" class="pa-5">
                                    <v-icon class="mr-2">mdi-calendar-check-outline</v-icon>
                                    Agendar turno
                                </v-btn>
                            </v-col>
                        </v-row>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="12" md="12">
                        <!--                         <v-btn type="onSubmit" :disabled="invalid" block elevation="0" color="primary lighten-1"
                            class="pa-5">
                            <v-icon class="mr-1">mdi-calendar-check-outline</v-icon>
                            Confirmar turno
                        </v-btn> -->
                    </v-col>
                </v-row>
            </v-form>
        </ValidationObserver>
    </div>
</template>

<script>
import DialogoTurno from '@/components/dialogos/DialogoTurno.vue';
import { ValidationProvider, ValidationObserver } from 'vee-validate';
import { mapActions, mapGetters } from 'vuex';

export default {
    name: 'form-nuevo-turno',
    components: {
        ValidationObserver,
        ValidationProvider,
        DialogoTurno
    },

    data() {
        return {
            valid: false,
            mail: '',
            dismissible: false,
            itemMotivo: [
                'Modificación de datos',
                'Pago por medios electrónicos',
                'Subsidios',
                'Préstamos',
                'Jubilación / Pensión',
                'Exención',
                'IOMA / UDEC',
                'Recupero años / Nivel',
                'Elección de Beneficiario',
                'Otros'
            ],
            nuevoTurno: {
                idDistrito: '',
                distrito: '',
                direccion: '',
                nroafi: '',
                hora: '',
                mail: '',
                fecha: '',
                motivo: '',
            },
            date: (new Date(Date.now() - (new Date())
                .getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
            options: { dateStyle: 'short' },
            hoy: (new Date(Date.now() - (new Date())
                .getTimezoneOffset() * 60000)).toISOString().substr(0, 10),

            // última fecha que se cargó datos desde los distritos para la disponibilidad de turnos
            finFecha: ''

        }
    },
    mounted() {
        this.getDistritos({ nroafi: this.nroafi, fecha2: this.date }) // output distritos: Array[]
    },
    computed: {
        ...mapGetters('auth', ['nroafi', 'emailAuth', 'email'],),
        ...mapGetters(['emailPrinc']),
        ...mapGetters('turnos', ['distritos', 'horarios', 'diasNoLaborables', 'ultimaFechaCargada']),

        filtroDiasNoLaborables() {
            return this.diasNoLaborables.map(({ desde }) => this.formatDate(desde));
        },
        fechaFormateada() {
            return this.formatDateAMDtoDMA(this.nuevoTurno.fecha)
        },
        emailAfiliado() {
            if (this.emailPrinc.email !== '') return this.emailPrinc.email
            else if (this.user.email !== '') return this.user.email
            else return this.emailAuth
        }
    },
    methods: {
        ...mapActions('notificaciones', ['showSnack']),
        ...mapActions('turnos', ['getDistritos', 'getDiasNoLaborables', 'getHorarios', 'solicitarTurno', 'guardarTurnoTmp', 'getTurnosActivos']),

        disablePastDates(val) {
            //let lastDate = new Date(this.diasNoLaborables[this.diasNoLaborables.length - 1].desde);
            //return selectedDate <= lastDate && val > new Date().toISOString().substr(0, 10);
            //return (val > new Date().toISOString().substr(0, 10) || lastDate.toISOString().substr(0, 10));
            const selectedDate = new Date(val)
            if (selectedDate.getDay() == 5 || selectedDate.getDay() == 6) {
                return false
            }
            return ((val >= new Date().toISOString().substr(0, 10)))
        },
        handleCalendarClick() {
            if (this.nuevoTurno.idDistrito == '') {
                this.dismissible = true
            }
        },
        handleDismissible() {
            this.dismissible = false
        },
        changeDistri(value) {
            this.getDiasNoLaborables({ distrito: value.id, nroafi: this.nroafi })
            this.nuevoTurno.direccion = value.direccion
            this.nuevoTurno.idDistrito = value.id
            this.nuevoTurno.distrito = value.desdistrito
            // Cambiar de distrito invalida todo lo demas: limpiar campos editables del form
            // para que el usuario empiece de cero con el nuevo distrito.
            this.nuevoTurno.fecha = ''
            this.nuevoTurno.hora = ''
            this.nuevoTurno.motivo = ''
            this.nuevoTurno.mail = ''
        },
        mostrarSnack() {
            this.showSnack({
                message: 'Seleccione primero distrito.',
                type: '500'
            })
        },
        setMail() {
            return this.nuevoTurno.mail = this.emailAuth
        },
        onSubmit() {
            this.$refs.obs.validate().then(result => {
                if (result) {
                    this.nuevoTurno.nroafi = this.nroafi
                    this.guardarTurnoTmp(this.nuevoTurno)
                    this.$refs.refDialogoTurno.abrirDialogo().then(result => {
                        if (result) {
                            this.solicitarTurno().then(() => {
                                this.getTurnosActivos({ nroafi: this.nroafi }).then(() => {
                                    //this.$emit('cerrar')
                                    location.reload()
                                })
                            })
                        } else {
                            this.guardarTurnoTmp({})
                        }

                    })
                } else {
                    console.log('Formulario inválido, turno no guardado');
                }
            });
        },

        formatDate(date) {
            if (!date) return null
            const [day, month, year] = date.split('/')
            return `${year}-${month}-${day}`
        },
        formatDateAMDtoDMA(date) {
            if (!date) return null
            const [year, month, day] = date.split('-')
            return `${day}/${month}/${year}`
        },
        async fechaSeleccionada(value) {
            if (this.nuevoTurno.idDistrito === "") {
                this.nuevoTurno.idDistrito = ""
                this.nuevoTurno.fecha = ""
                this.nuevoTurno.hora = ""
                this.dismissible = true
                return
            }

            // Al cambiar de fecha la hora elegida deja de ser valida (los horarios son por fecha).
            // Limpiar antes del await evita que el boton "Agendar turno" siga habilitado mientras
            // se espera la respuesta o si el back devuelve success: 0.
            this.nuevoTurno.hora = ""

            if (this.filtroDiasNoLaborables.includes(value)) {
                this.nuevoTurno.fecha = ''
                this.showSnack({
                    message: 'Fecha no disponible.',
                    type: '400'
                })
                return
            }

            await this.getHorarios({
                nroafi: this.nroafi,
                fecha2: value,
                fecha: this.formatDateAMDtoDMA(value),
                idDistrito: this.nuevoTurno.idDistrito,
                dia: this.getDayOfWeek(value)
            })

            if (this.horarios.length === 0) {
                this.nuevoTurno.fecha = ''
                this.showSnack({
                    message: 'No hay horarios disponibles para la fecha seleccionada.',
                    type: '400'
                })
            }
        },
        linkWithModal() {
            this.$emit('cerrar')
        },
        getDayOfWeek(dateString) {
            //const daysOfWeek = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
            const date = new Date(dateString);
            const dayOfWeekIndex = date.getDay();
            return dayOfWeekIndex;
        }
    },
    watch: {
    }
}

</script>

<style>
.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.5s;
}

.fade-enter,
.fade-leave-to {
    opacity: 0;
}
</style>